// extracted by mini-css-extract-plugin
export var root = "xE85";
export var rootIcon = "kU5T";
export var rootStarsCount = "Ukrw";
export var rootStarsWrapper = "jE5L";